export { default } from "./CoreRecord";
